var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "additional-phone": _vm.isAdditionalPhone,
      },
    },
    [
      _c("m-field-reference-book", {
        ref: "referencesModal",
        attrs: { "field-name": _vm.dictionaryFieldName },
        on: { updated: _vm.updateListVariants },
      }),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("c-checkbox", {
            attrs: { type: "checkbox", label: _vm.customLabel },
            model: {
              value: _vm.form.custom,
              callback: function ($$v) {
                _vm.$set(_vm.form, "custom", $$v)
              },
              expression: "form.custom",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("c-checkbox", {
            attrs: { type: "checkbox", label: _vm.saveCustomLabel },
            model: {
              value: _vm.form.saveCustom,
              callback: function ($$v) {
                _vm.$set(_vm.form, "saveCustom", $$v)
              },
              expression: "form.saveCustom",
            },
          }),
        ],
        1
      ),
      _vm.form.variants.length
        ? _c("c-button", {
            attrs: {
              responsive: true,
              size: "small",
              icon: { icon: "edit" },
              label: _vm.editDictionaryLabel,
            },
            on: { click: _vm.editReferences },
          })
        : _c("c-button", {
            attrs: {
              responsive: true,
              size: "small",
              color: "primary",
              icon: { icon: "plus", color: "white" },
              label: "Создать справочник",
            },
            on: { click: _vm.editReferences },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }